import { nsT, useT } from '../../index';
import type zh from './zh-CN';

export type AuthMessages = typeof zh;
export const useAuthT = () => useT<AuthMessages>('auth');
export const authT = nsT<AuthMessages>('auth');
